import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import NoDataFound from '../../NoDataFound/NoDataFound';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const RegionalShareChart = ({ chartData }) => {
  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }

  const sortedData = [...chartData].sort((a, b) =>
    a.geographical.localeCompare(b.geographical)
  );

  const labels = sortedData.map(item =>
    item.geographical.charAt(0).toUpperCase() + item.geographical.slice(1)
  );

  const dataValues = sortedData.map(item =>
    parseFloat(item.percentage.replace('%', ''))
  );

  const hasData = dataValues.some(value => value > 0);
  if (!hasData) {
    return <NoDataFound height={300} />;
  }

  const backgroundColors = ['#ff4c91', '#7f7fff', '#4dd0e1'];

  const data = {
    labels,
    datasets: [
      {
        data: dataValues,
        backgroundColor: backgroundColors,
        borderWidth: 2,
        hoverOffset: 20
      }
    ]
  };

  const options = {
    plugins: {
      datalabels: {
        color: 'white',
        formatter: value => `${value.toFixed(1)}%`,
        font: {
          weight: 'bold',
          size: 14
        }
      },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: ${ctx.raw.toFixed(1)}%`
        }
      },
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle'
        }
      },
    }
  };

  return <Pie data={data} options={options} />;
};

export default RegionalShareChart;
